import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  inject,
  input,
  output,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[libScrollBottom]',
  standalone: true,
})
export class ScrollBottomDirective implements OnInit, OnDestroy {
  /** Pixels from the bottom that trigger the emit (default: 200) */
  threshold = input<number>(200);

  scrolledBottom = output<void>();

  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private scrollSub?: Subscription;

  ngOnInit(): void {
    this.onScroll();
  }
  onScroll() {
    this.scrollSub = fromEvent(this.el.nativeElement, 'scroll').subscribe(
      () => {
        const { scrollTop, scrollHeight, clientHeight } = this.el.nativeElement;
        if (scrollTop + clientHeight >= scrollHeight - this.threshold()) {
          this.scrolledBottom.emit();
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.scrollSub?.unsubscribe();
  }
}
